<div class="popup-overlay" *ngIf="isvisible" (click)="closePopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="popup-header">
      <h3>{{ 'Select Your CV' | translate }}</h3>
      <button class="close-btn" (click)="closePopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="loading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p>{{ 'Loading your CVs...' | translate }}</p>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="error && !loading">
      <i class="bi bi-exclamation-circle"></i>
      <p>{{ error | translate }}</p>
      <button class="retry-btn" (click)="loadPaidCVs()">
        {{ 'Retry' | translate }}
      </button>
    </div>

    <!-- CVs Grid -->
    <div class="cvs-container" *ngIf="!loading && !error">
      <div class="empty-state" *ngIf="generatedCvs.length === 0">
        <i class="bi bi-file-earmark-text"></i>
        <p>{{ 'No paid CVs available' | translate }}</p>
        <small>{{ 'Purchase a CV to see it here' | translate }}</small>
      </div>

      <div class="cv-grid" *ngIf="generatedCvs.length > 0">
        <div class="cv-item" *ngFor="let cv of generatedCvs; let i = index" (click)="selectCV(cv)">
          <div class="cv-image-container">
            <!-- Loading spinner for image -->
            <div class="image-loading" *ngIf="!cvImageUrls[cv.imagePath]">
              <div class="spinner-border spinner-border-sm text-danger" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            
            <!-- Actual Image -->
            <img 
              *ngIf="cvImageUrls[cv.imagePath]"
              [src]="getImageUrl(cv.imagePath)" 
              [alt]="'CV Template ' + (i + 1)"
              (contextmenu)="disableRightClick($event)"
            />
            
            <div class="cv-overlay">
              <i class="bi bi-check-circle-fill"></i>
              <span>{{ 'Select' | translate }}</span>
            </div>
          </div>
          <div class="cv-info">
            <span class="cv-number">CV #{{ i + 1 }}</span>
            <div class="cv-badges">
              <span class="badge badge-pdf" *ngIf="cv.pdfPath">
                <i class="bi bi-file-pdf"></i> PDF
              </span>
              <span class="badge badge-word" *ngIf="cv.wordPath">
                <i class="bi bi-file-word"></i> Word
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>